import { SelectedProgramContextTab, SelectedProgramContextTabParams } from './types';
import { ROUTES } from 'app/routes';

export const programContextPageRoute = `${ROUTES.JOB_SEEKER.EXPLORE_PROGRAMS}/:programId`;

export const programContextPagesRoutes: { tab: SelectedProgramContextTab; route: string }[] = [
  { tab: SelectedProgramContextTab.GroupHub, route: ROUTES.JOB_SEEKER.PROGRAM_CONTEXT.RESOURCES },
  { tab: SelectedProgramContextTab.GroupProductsAndServices, route: ROUTES.JOB_SEEKER.PROGRAM_CONTEXT.RESOURCES_PRODUCTS_SERVICES },
  { tab: SelectedProgramContextTab.GroupEvents, route: ROUTES.JOB_SEEKER.PROGRAM_CONTEXT.RESOURCES_EVENTS },
  { tab: SelectedProgramContextTab.GroupMembers, route: ROUTES.JOB_SEEKER.PROGRAM_CONTEXT.JOB_SEEKERS },
  { tab: SelectedProgramContextTab.GroupAbout, route: ROUTES.JOB_SEEKER.PROGRAM_CONTEXT.ABOUT },
];

export const ProgramContextTabToRoute: Record<SelectedProgramContextTab, string> = {
  [SelectedProgramContextTab.GroupHub]: SelectedProgramContextTabParams.GroupResources,
  [SelectedProgramContextTab.GroupProductsAndServices]: SelectedProgramContextTabParams.GroupResourcesProductsAndServices,
  [SelectedProgramContextTab.GroupEvents]: SelectedProgramContextTabParams.GroupResourcesEvents,
  [SelectedProgramContextTab.GroupMembers]: SelectedProgramContextTabParams.GroupMembers,
  [SelectedProgramContextTab.GroupAbout]: SelectedProgramContextTabParams.GroupAbout,
};

export const ProgramContextRouteToTab: Record<string, SelectedProgramContextTab> = {
  [SelectedProgramContextTabParams.GroupResources]: SelectedProgramContextTab.GroupHub,
  [SelectedProgramContextTabParams.GroupResourcesProductsAndServices]: SelectedProgramContextTab.GroupProductsAndServices,
  [SelectedProgramContextTabParams.GroupResourcesEvents]: SelectedProgramContextTab.GroupEvents,
  [SelectedProgramContextTabParams.GroupMembers]: SelectedProgramContextTab.GroupMembers,
  [SelectedProgramContextTabParams.GroupAbout]: SelectedProgramContextTab.GroupAbout,
};

export const getProgramContextTabParamRoute = (segment?: string, defaultValue: SelectedProgramContextTab = SelectedProgramContextTab.GroupHub): SelectedProgramContextTab => {
  return segment ? ProgramContextRouteToTab[segment] ?? defaultValue : defaultValue;
};

export const getProgramContextTabRouteParam = (tab?: SelectedProgramContextTab, defaultValue: SelectedProgramContextTabParams = SelectedProgramContextTabParams.GroupResources): string => {
  return tab ? ProgramContextTabToRoute[tab] ?? defaultValue : defaultValue;
};
